import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import 'semantic-ui/semantic';

import { environment } from '@nstep-public/environments/environment';
import { AppModule } from '@nstep-public/app/app.module';

if (environment.disableConsoleLogs) {
	window.console.log = function () {
		return;
	};

	window.console.info = function () {
		return;
	};

	window.console.debug = function () {
		return;
	};

	window.console.warn = function () {
		return;
	};

	window.console.group = function () {
		return;
	};

	window.console.groupCollapsed = function () {
		return;
	};

	window.console.groupEnd = function () {
		return;
	};
}

if (environment.target == 'production') {
	enableProdMode();
}

(function () {
	const originalToISOString = Date.prototype.toISOString;
	const originalToJSON = Date.prototype.toJSON;

	function isMidnightLocal(date: Date) {
		return date.getHours() === 0 &&
			date.getMinutes() === 0 &&
			date.getSeconds() === 0 &&
			date.getMilliseconds() === 0;
	}

	function formatLocalDateOnly(date: Date) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');

		return `${year}-${month}-${day}`;
	}

	Date.prototype.toISOString = function () {
		if (isMidnightLocal(this)) {
			return formatLocalDateOnly(this);
		}

		return originalToISOString.call(this);
	};

	Date.prototype.toJSON = function () {
		if (isMidnightLocal(this)) {
			return formatLocalDateOnly(this);
		}

		return originalToJSON.call(this);
	};
})();

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
